<script setup lang="ts">
  import { useAppRouting } from '@/composables/useAppRouting'
  import { KsButton } from '@aschehoug/kloss'
  import VgsButton from '@/components/common/VgsButton.vue'
  import { nextTick } from 'vue'

  const { getParentRoute } = useAppRouting()
  defineProps<{
    isFirstPage?: boolean
    isLastPage?: boolean
  }>()

  const emit = defineEmits(['previous', 'next'])

  const forceResizeIfGeoGebraTask = () => {
    if (!document.querySelector('.geogebra-applet')) return
    window.dispatchEvent(new Event('resize'))
  }

  const handlePrevious = () => {
    window.scrollTo({ top: 0 })
    emit('previous')
    // wrap in nextTick to ensure the resize event is triggered after the applet has been rendered
    nextTick(forceResizeIfGeoGebraTask)
  }

  const handleNext = () => {
    window.scrollTo({ top: 0 })
    emit('next')
    nextTick(forceResizeIfGeoGebraTask)
  }
</script>

<template>
  <footer :class="['focus-task-footer']">
    <div class="focus-task-footer__button-group">
      <KsButton
        v-if="!isLastPage"
        class="next-button"
        variant="tertiary"
        @click="handleNext"
      >
        Neste
      </KsButton>
      <router-link
        :to="getParentRoute()"
        class="link"
      >
        <KsButton
          v-if="isLastPage"
          type="label"
          variant="tertiary"
          class="next-button"
        >
          Avslutt
        </KsButton>
      </router-link>
      <VgsButton
        v-if="!isFirstPage"
        class="previous-button"
        variant="link"
        :disabled="isFirstPage"
        @click="handlePrevious"
      >
        Forrige
      </VgsButton>
    </div>
  </footer>
</template>

<style scoped lang="scss">
  footer {
    grid-area: footer;
  }

  .focus-task-footer {
    background-color: var(--color-blue-40);
    position: sticky;
    bottom: 0;
    width: 100%;
    padding: 12px 72px;
    z-index: 90;

    @media (width >= 1200px) {
      padding-left: 160px;
    }

    @include horizontal-padding-mobile;

    &__button-group {
      display: flex;
      align-items: center;
      column-gap: 16px;
      width: fit-content;
    }

    .next-button,
    .previous-button {
      &.ks-button {
        &:disabled {
          visibility: hidden;
        }

        &:not(.vgs-button) {
          background-color: transparent;
          color: var(--color-white);
          border-radius: 50px;
          border: 2px solid var(--color-white);
        }
      }
    }

    .link {
      color: var(--color-white);
      text-decoration: none;

      &:focus-within {
        .ks-button {
          @include focus-ring;
        }
      }
    }
  }
</style>
